import { render, staticRenderFns } from "./FitPayment.vue?vue&type=template&id=28619557&"
import script from "./FitPayment.vue?vue&type=script&lang=js&"
export * from "./FitPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports